import apiDataResponseHandler from 'util/promiseFactory/apiDataResponseHandler';
import { getPublisherAutosuggestJF } from 'app/services/partner/autosuggest';
import withInputErrorMessage from '../withInputErrorMessage';
import autosuggestFactory from './autosuggestFactory';
import withAutosuggestWrapper from './withAutosuggestWrapper';

const JobGroupAutosuggestJF = autosuggestFactory({
   apiPromise: getPublisherAutosuggestJF,
   handleApiDataResponse: apiDataResponseHandler.withSuggestionsFromDataPropAndNameAsLabel,
   defaultPlaceholder: 'Search Partner...',
});

export default withAutosuggestWrapper(withInputErrorMessage(JobGroupAutosuggestJF));
